import { Box, TableCell, TableRow, Typography, Switch } from "@mui/material";
import type { TemplateInformation } from "../../types/api-types";

interface TemplateTableRowProps {
  template: TemplateInformation;
  onSelect: (template: TemplateInformation) => void;
  onToggleValidator: (template: TemplateInformation, checked: boolean) => void;
  isSaving: boolean;
}

const TemplateTableRow = ({
  template,
  onSelect,
  onToggleValidator,
  isSaving,
}: TemplateTableRowProps) => {
  return (
    <TableRow
      onClick={() => onSelect(template)}
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
        cursor: "pointer",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: (theme) => theme.palette.action.hover,
          transform: "scale(1.001)",
        },
      }}
    >
      <TableCell sx={{ py: 1 }}>
        <Typography
          sx={{
            color: "primary.main",
            fontWeight: 500,
            fontSize: "0.875rem",
          }}
        >
          {template.description}
        </Typography>
      </TableCell>
      <TableCell align="center" sx={{ py: 1, width: 250 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Switch
            checked={template.useDataValidator}
            onChange={(e) => onToggleValidator(template, e.target.checked)}
            disabled={isSaving}
            color="success"
          />
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default TemplateTableRow;
